import { render } from "./VanillaOrigins.vue?vue&type=template&id=5df047a2&scoped=true"
import script from "./VanillaOrigins.vue?vue&type=script&lang=js"
export * from "./VanillaOrigins.vue?vue&type=script&lang=js"

import "./VanillaOrigins.vue?vue&type=style&index=0&id=5df047a2&lang=scss&scoped=true"

import exportComponent from "/builds/optelgroup/exploration/reusable-components/supply-chain-simulator/prototype/iscp-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df047a2"]])

export default __exports__